module.exports = __webpack_public_path__ + "static/empty-cart-98d98a6bde0401edb4499c034726f5b3.svg";